import { h, VNode } from 'preact';

export function AppStoreLinks(): VNode {
  return (
    <div className="row">
      <a
        href="https://play.google.com/store/apps/details?id=se.nightli"
        target="_blank"
        className="w-inline-block"
        rel="noreferrer">
        <img
          src="https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download.png"
          loading="lazy"
          width="150"
          sizes="(max-width: 166px) 100vw, (max-width: 767px) 200.0077362060547px, (max-width: 991px) 25vw, 205.00001525878906px"
          srcset="https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-500.png 500w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-800.png 800w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-1080.png 1080w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-1600.png 1600w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-2000.png 2000w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download-p-2600.png 2600w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5d49a8cd2b6f3ac853d8_google-download.png 5400w"
          alt="download the nightli app on google play"
        />
      </a>
      <a
        href="https://apps.apple.com/se/app/nightli-nightclubs-events/id6443802524"
        target="_blank"
        className="w-inline-block"
        rel="noreferrer">
        <img
          src="https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5e1c3b8992cc86779727_apple-download-nightli.png"
          loading="lazy"
          width="150"
          sizes="(max-width: 166px) 100vw, (max-width: 767px) 200.0077362060547px, (max-width: 991px) 25vw, 205.00001525878906px"
          srcset="https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5e1c3b8992cc86779727_apple-download-nightli-p-500.png 500w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5e1c3b8992cc86779727_apple-download-nightli-p-800.png 800w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5e1c3b8992cc86779727_apple-download-nightli-p-1080.png 1080w, https://uploads-ssl.webflow.com/604e5bf6813f947d0e60c30d/604e5e1c3b8992cc86779727_apple-download-nightli.png 1296w"
          alt="download the nightli app on appstore"
        />
      </a>
    </div>
  );
}
